import React from 'react';

const InputCnpj = ({
  id,
  className,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  legenda,
  ...rest
}) => {
  const normalizarCnpj = (valor) => {
    const cnpjSemMascara = valor.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    const base = cnpjSemMascara.slice(0, 12);
    const dv = cnpjSemMascara
      .slice(12)
      .replace(/\D/g, '')
      .slice(0, 2);

    return `${base}${dv}`;
  };

  const aplicarMascaraCnpj = (valor) => {
    const cnpj = normalizarCnpj(valor);

    if (cnpj.length <= 2) return cnpj;
    if (cnpj.length <= 5) return `${cnpj.slice(0, 2)}.${cnpj.slice(2)}`;
    if (cnpj.length <= 8)
      return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5)}`;
    if (cnpj.length <= 12)
      return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8)}`;

    return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8, 12)}-${cnpj.slice(12, 14)}`;
  };

  const handlePaste = (e) => {
    const cnpjCopiado = e.clipboardData.getData('Text');
    const cnpjNormalizado = normalizarCnpj(cnpjCopiado);

    if (cnpjNormalizado.length === 14) {
      e.preventDefault();
      e.target.value = aplicarMascaraCnpj(cnpjNormalizado);
    }
  };

  const handleInput = (e) => {
    e.target.value = aplicarMascaraCnpj(e.target.value);
  };

  const handleKeyDown = (e) => {
    let invalidChars = ['.', '-', '/'];
    const key = e.key;

    if (invalidChars.includes(key)) {
      e.preventDefault();
    }

    if (key !== 'Backspace' && key !== 'Delete') {
      //verifica se a tecla precionada nao e um backspace e delete
      var i = e.target.value.length; //aqui pega o tamanho do input
      if (i === 2 || i === 6)
        //aqui faz a divisoes colocando um ponto no terceiro e setimo indice
        e.target.value = e.target.value + '.';
      else if (i === 10)
        //aqui faz a divisao colocando o traço no decimo primeiro indice
        e.target.value = e.target.value + '/';
      else if (i === 15)
        //aqui faz a divisao colocando o traço no decimo sexto indice
        e.target.value = e.target.value + '-';
    }
  };

  const msgErro = errors && errors[name]?.message;
  return (
    <div className={`campo-txt ${msgErro ? 'erro' : ''}`}>
      <label className={`subtitulo-p`} htmlFor={id}>
        {label}
      </label>

      <div className="input-container">
        <input
          type={'text'}
          id={id}
          name={name}
          ref={inputRef}
          className={className}
          //pattern='\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}'
          placeholder="AA.AAA.AAA/AAAA-NN"
          maxLength="18"
          autoComplete="off"
          onInput={(e) => handleInput(e)}
          onKeyDown={(e) => handleKeyDown(e)}
          onPaste={(e) => handlePaste(e)}
          {...rest}
        />
      </div>
      <div className="mensagem legenda">
        {legenda} {msgErro}
      </div>
    </div>
  );
};

export default InputCnpj;
